/* NOCTURA transitions — v2 (Shop v2 page wipe)
   Leaving: a full-screen surface panel slides up from the bottom (0.7s),
   showing the print's title when the link carries data-wipe-label, then the
   browser navigates. Arriving: theme.liquid sees the sessionStorage flag set
   here and adds html.nt-arrive before first paint; noctura-nocturne.css then
   lifts the same panel away upward (0.8s) with no JavaScript involved.
   Also: hover prefetch, so the next page is half-loaded before the click
   (2026-10-30 patch 3: only in browsers without Speculation Rules, F-047).

   Progressive enhancement — with this script absent, in the theme editor, or
   with reduced motion, every link is a plain instant navigation.

   SAFETY NOTES
   - The click handler runs after noctura.js (script order) and bails on
     e.defaultPrevented, so drawer / quantity / sort / colourway handlers win.
   - The panel is a popover, so it paints above an open <dialog> (the
     full-screen menu) instead of underneath it. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EDITOR = !!(window.Shopify && Shopify.designMode);
  if (EDITOR) return;

  /* ---------- which links transition ---------- */
  function navUrl(a, e) {
    if (e && (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return null;
    if (!a || (a.target && a.target !== '_self')) return null;
    if (a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return null;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return null;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return null; }
    if (url.origin !== location.origin) return null;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return null;
    if (/^\/(cart|checkout|account)/.test(url.pathname)) return null;
    return url;
  }

  /* ---------- the panel ---------- */
  var panel = null;
  var label = null;
  function build() {
    if (panel) return;
    panel = document.createElement('div');
    panel.className = 'nt-wipe';
    panel.setAttribute('aria-hidden', 'true');
    if ('popover' in HTMLElement.prototype) panel.setAttribute('popover', 'manual');
    label = document.createElement('span');
    label.className = 'nt-wipe__label';
    panel.appendChild(label);
    document.body.appendChild(panel);
  }
  function cover(text, then) {
    build();
    label.textContent = text || '';
    if (panel.showPopover) {
      try { panel.showPopover(); } catch (err) {}
    }
    void panel.offsetWidth;
    requestAnimationFrame(function () {
      panel.classList.add('is-cover');
      setTimeout(then, 720);
    });
  }
  function reset() {
    if (!panel) return;
    panel.classList.remove('is-cover');
    if (panel.hidePopover) {
      try { panel.hidePopover(); } catch (err) {}
    }
  }

  /* back/forward cache restore: the page comes back covered. Lift it. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      reset();
      try { sessionStorage.removeItem('nt-wipe'); } catch (err) {}
    }
  });

  if (!REDUCE) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      var url = navUrl(a, e);
      if (!url) return;
      e.preventDefault();
      var text = a.getAttribute('data-wipe-label') || '';
      try { sessionStorage.setItem('nt-wipe', '1'); } catch (err) {}
      cover(text, function () { location.href = url.href; });
      /* failsafe: a cancelled navigation (Esc, stop button, a link that turns
         into a download) keeps this page — lift the panel rather than
         stranding the shopper behind it */
      setTimeout(function () {
        reset();
        try { sessionStorage.removeItem('nt-wipe'); } catch (err) {}
      }, 4000);
    });
  }

  /* ---------- hover prefetch: pages are half-loaded before the click ----------
     2026-10-30 patch 3: skipped where the browser supports Speculation Rules
     (Chrome, Edge): Shopify's Speculation-Rules header already prefetches the
     same links on hover, so this made a second ~40 KB fetch of each page.
     Firefox and other browsers without them keep this prefetch (F-047). */
  var conn = navigator.connection;
  var SPEC = !!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'));
  if (!SPEC && !(conn && (conn.saveData || /2g/.test(conn.effectiveType || '')))) {
    var seen = {};
    var SKIP = /^\/(cart|checkout|account|search)/;
    var warm = function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      var url = navUrl(a, null);
      if (!url || seen[url.pathname + url.search] || SKIP.test(url.pathname)) return;
      seen[url.pathname + url.search] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = url.href;
      document.head.appendChild(l);
    };
    document.addEventListener('mouseover', warm, { passive: true });
    document.addEventListener('touchstart', warm, { passive: true });
  }
})();
